function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "48C768B8-79C6-44B4-9C29-87B86517BDAB");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Admissions",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "anuAdmissionsCareerInfo",
  transform: "translate(-1271.000000, -413.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "sideBar",
  transform: "translate(1236.000000, 309.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "sidebarSection1",
  transform: "translate(0.000000, 90.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "groupSidebarHeader"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.5,27 C45.0898556,27 48,24.0898556 48,20.5 C48,16.9101444 45.0898556,14 41.5,14 C37.9101444,14 35,16.9101444 35,20.5 C35,24.0898556 37.9101444,27 41.5,27 Z M40.7171367,23.8625339 L38.1171327,20.8117454 C37.9609558,20.628462 37.9609558,20.3312496 38.1171327,20.1479662 L38.6828319,19.4842158 C38.8390333,19.3009324 39.0923295,19.3009324 39.248531,19.4842158 L41,21.5393786 L44.751469,17.137484 C44.9076949,16.954172 45.1609912,16.954172 45.3171681,17.137484 L45.8828673,17.8012345 C46.0390442,17.9845178 46.0390442,18.2817302 45.8828673,18.4650136 L41.2828602,23.8625625 C41.1266344,24.0458173 40.8733625,24.0458173 40.7171367,23.8625339 Z",
  id: "iconStatusCheckCircle"
}))))));

var SvgCheckTab = function SvgCheckTab(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckTab, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-tab.4eab1864.svg";
export { ForwardRef as ReactComponent };